import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const UserGroupRightService = {
  getUserGroupRight(obj) {
    return httpClient.post(endPoints.getUserGroupRight, obj);
  },
  getMenuRightForUser(obj) {
    return httpClient.post(endPoints.getMenuRightForUser, obj);
  },
  deleteUserGroupRight(obj) {
    return httpClient.post(endPoints.deleteUserGroupRight, obj);
  },
  updateUserGroupRight(obj) {
    return httpClient.post(endPoints.updateUserGroupRight, obj);
  },
  addUserGroupRight(obj) {
    return httpClient.post(endPoints.addUserGroupRight, obj);
  }
};

export default UserGroupRightService;



// WEBPACK FOOTER //
// ./src/service/UserGroupRightService.js